import { Component, OnInit, Injector } from '@angular/core';
import { MultilingualData } from '@clients/member-direct/translation';
import { select } from '@ngrx/store';
import { selectHeaderActions } from 'libs/member-direct/surveys/src/lib/+state/selectors';
import { BaseElement } from 'libs/member-direct/surveys/src/lib/base-element.abstract';
import { SurveyElement } from 'libs/member-direct/surveys/src/models/survey/ISurveyElement';
import { Observable } from 'rxjs';

@Component({
    selector: 'member-direct-header-actions',
    templateUrl: './header-actions.component.html',
    styleUrls: ['./header-actions.component.scss']
})
export class HeaderActionsComponent extends BaseElement implements OnInit {
    public actions: Observable<Partial<SurveyElement>>;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.actions = this.store.pipe(select(selectHeaderActions));
    }
}
